import React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useGetStaticAssetUrl } from '@change-corgi/core/react/assets';
import { TranslateHtml, useI18n } from '@change-corgi/core/react/i18n';

import { useButtonContainer } from './hooks/useButtonContainer';

type Props = Parameters<typeof useButtonContainer>[0];

export const ButtonContainer: React.FC<Props> = (props) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const { translate } = useI18n();
	const {
		data: { selectedAmount, buttonAmounts, buttonText, ctaButtonLink, otherLink, paymentTerm },
		actions: { onClick },
	} = useButtonContainer(props);

	return (
		<div className="flex flex-col gap-2">
			<div className="grid grid-cols-2 gap-2">
				{buttonAmounts.map(({ amount, amountLocalized, link }, index) => {
					return (
						<div
							key={amount}
							className={cn('rounded-lg p-0.5', {
								'bg-gradient-fill-progress': amount === selectedAmount.amount,
							})}
						>
							<Button
								as="a"
								className="bg-fill-inverse-strong h-full w-full"
								target="_blank"
								variant="secondary-solid"
								href={link}
								onClick={onClick}
								data-qa={`membership-popup-amount-button-${index}`}
							>
								{paymentTerm === 'yearly' &&
									translate('corgi.membership.manage.amount_per_year', { amount: amountLocalized })}
								{paymentTerm === 'monthly' &&
									translate('fe.pages.subscriptions.manage.amount_per_month', { amount: amountLocalized })}
								{paymentTerm === 'one-time' && amountLocalized}
							</Button>
						</div>
					);
				})}
			</div>
			<Button
				as="a"
				variant="secondary-solid"
				target="_blank"
				href={otherLink}
				onClick={onClick}
				data-qa="membership-popup-other-button"
			>
				{translate('corgi.membership.awareness.other_amount_label')}
			</Button>
			<Button
				as="a"
				variant="primary"
				target="_blank"
				href={ctaButtonLink}
				onClick={onClick}
				data-qa="membership-popup-continue-button"
			>
				{buttonText}
			</Button>
			<div className="text-center">
				<Text>
					<TranslateHtml
						value="corgi.membership.awareness.pay_with"
						replacements={{
							paypalImageElement: (
								<img alt="paypal" src={getStaticAssetUrl('/membership/paypal.svg')} className="inline" />
							),
						}}
					/>
				</Text>
			</div>
		</div>
	);
};
